import { flex } from "@styled-system/patterns";

export const buttonWrapperClass = flex({
	gap: "4",
});
